import { InlineBanner, Link, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React from 'react'

interface Props {
  shouldShowReturnBanner: boolean
}

export const SaleReturnBanner: React.FC<Props> = ({
  shouldShowReturnBanner,
}) => {
  const t = useT()

  return (
    shouldShowReturnBanner && (
      <InlineBanner variant="info" icon="undo">
        <Text type="label">
          {t('Are you making a return?', { _context: 'Sale return banner' })}
          &nbsp;
          <Link
            isSecondary
            data-track="find-the-original-sale"
            href="/sales/completed"
          >
            {t('Find the original sale', {
              _context: 'Sale return banner link',
            })}
          </Link>
        </Text>
      </InlineBanner>
    )
  )
}
